import { make } from 'vuex-pathify';
import { state as productUpgrade } from '@/store/productUpgrade';

const actions = {
  ...make.actions(productUpgrade),
};

export { actions };
